import { Router, Routes } from '@angular/router';

import { ContentWrapperComponent } from '../../../../app/content-wrapper/components/content-wrapper/content-wrapper.component';
import { ILayoutMicrofrontend } from '../../models/layout/layout-microfrontend.interface';
import {
  IServiceResponseFullPageWidget,
  IServiceResponseMenuItemType
} from '../../models/services/response-app/response-app-menu-item.interface';
import { IServiceResponseWidgets } from '../../models/services/response-app/response-app-widgets.interface';
import { IServiceResponseNavigationTree } from '../../models/services/response-app/response-app.interface';
import { PageTypeEnum } from './router-loader.enum';

export class RouterLoaderHelper {
  /**,
   * Create new routes dynamically by reseting router configs inserting new routes
   * @param response Menu options fetched from /app api
   */
  static async setRoutesPaths(response: IServiceResponseNavigationTree, router: Router) {
    let paths = router.config;
    let hasHome = false;

    for (const menuItem of response.menu) {
      if (menuItem.tipo_pagina === PageTypeEnum.MODAL) {
        continue;
      }

      if (
        (menuItem.tipo_pagina === PageTypeEnum.SIMPLE || menuItem.tipo_pagina === PageTypeEnum.HIDDEN) &&
        menuItem.widget_layouts &&
        response.widgets
      ) {
        if (menuItem.tipo_pagina === PageTypeEnum.SIMPLE && menuItem.path === 'home') {
          hasHome = true;
        }

        const newPath = {
          path: RouterLoaderHelper.getMainPath(menuItem.path),
          component: ContentWrapperComponent,
          data: { mfe: RouterLoaderHelper.getPageWidgets(menuItem.widget_layouts, response.widgets) }
        };

        paths = [newPath, ...paths];
      }

      if (menuItem.grupo_sub_menus) {
        menuItem.grupo_sub_menus.forEach((subPageGroup) => {
          for (const subPage of subPageGroup.sub_menus) {
            if (subPage.tipo_pagina === PageTypeEnum.MODAL || !subPage.widget_layouts || !response.widgets) {
              continue;
            }

            const newSubpagePath = {
              path: RouterLoaderHelper.getMainPath(subPage.path),
              component: ContentWrapperComponent,
              data: { mfe: RouterLoaderHelper.getPageWidgets(subPage.widget_layouts, response.widgets) }
            };
            paths = [newSubpagePath, ...paths];
          }
        });
      }

      if (!menuItem.sub_menus) {
        continue;
      }
      menuItem.sub_menus.forEach((subpage: IServiceResponseMenuItemType) => {
        if (!subpage.widget_layouts || !response.widgets) {
          return;
        }
        const newSubpagePath = {
          path: RouterLoaderHelper.getMainPath(subpage.path),
          component: ContentWrapperComponent,
          data: { mfe: RouterLoaderHelper.getPageWidgets(subpage.widget_layouts, response.widgets) }
        };
        paths = [newSubpagePath, ...paths];
      });
    }

    if (!hasHome) {
      const initialPageIndex = response.menu.findIndex(
        (el) => el.tipo_pagina === PageTypeEnum.SIMPLE || el.tipo_pagina === PageTypeEnum.DESCRITIVE
      );
      const initialPage = response.menu[initialPageIndex];
      paths = RouterLoaderHelper.setInitialPath(initialPage, paths);
    }
    router.resetConfig(paths);
  }

  /**
   * Quando não há a pagina home definida na API, define a página inicial como
   * a primeira do tipo página simples ou a primeira subpágina da descritiva
   * @param paths Lista de endpoints disponíveis para a aplicação
   * @returns Lista atualizada de endpoints
   */
  static setInitialPath(initialPage: IServiceResponseMenuItemType, paths: Routes) {
    const subpages = initialPage.sub_menus || [];
    const newRoute = initialPage.path || subpages[0].path;

    for (const page of paths) {
      if (page.path === 'home') {
        page.redirectTo = newRoute;
        delete page.component;
      }

      if (page.redirectTo === 'home') {
        page.redirectTo = newRoute;
      }
    }

    return paths;
  }

  /**
   * Gets page widgets based on widget id reference
   * @param pathWidgetReferences References of widgets that composes the page
   * @param pathWidgetList Available application widget list
   * @returns Complete page widget list and details
   */
  static getPageWidgets(
    pathWidgetReferences: IServiceResponseFullPageWidget[],
    pathWidgetList: IServiceResponseWidgets[]
  ): ILayoutMicrofrontend[] {
    let widgetArrays: any[] = [];
    pathWidgetReferences.forEach((widgetReference) => {
      const filteredWidgets = pathWidgetList
        .filter((widget) => {
          if (widget.tag_html !== widgetReference.widget_tag) {
            return;
          }
          widget.layout = { ...widgetReference.layout };
          return { ...widget };
        })
        .map((widget) => {
          return { ...widget };
        });
      widgetArrays = [...widgetArrays, ...filteredWidgets];
    });

    widgetArrays = widgetArrays.sort((widget, compare) => {
      return Number(widget.layout.ordem) - Number(compare.layout.ordem);
    });
    return widgetArrays;
  }

  static getMainPath(path: string | undefined): string | undefined {
    return path?.split('?')[0];
  }
}
